import { CartCardStyled } from "./style";
import { StyledTitle } from "../../../style/typography";
import { useContext } from "react";
import { CartContext } from "../../../providers/CartContext";
import { iCartItemProps } from "../@types";
import trasher from "../../../assets/img/trasher.svg";
export const CartCard = ({ itemCart }: iCartItemProps) => {
  const { addCountProduct, subCountProduct, removeButton } =
    useContext(CartContext);

  return (
    <CartCardStyled>
      <img src={itemCart.img} alt={itemCart.name} />
      <div>
        <StyledTitle tag="heading4" titleStyle="heading4">
          {itemCart.name}
        </StyledTitle>
        <div>
          <button onClick={() => subCountProduct(itemCart.id)}>-</button>
          <span>{itemCart.quantity}</span>
          <button onClick={() => addCountProduct(itemCart.id)}>+</button>
        </div>
      </div>
      <button onClick={() => removeButton(itemCart.id)}>
        <img src={trasher} alt="" />
      </button>
    </CartCardStyled>
  );
};
